import { render, staticRenderFns } from "./RegisterShiftSubject.vue?vue&type=template&id=7b23c516&scoped=true"
import script from "./RegisterShiftSubject.vue?vue&type=script&lang=js"
export * from "./RegisterShiftSubject.vue?vue&type=script&lang=js"
import style0 from "./RegisterShiftSubject.vue?vue&type=style&index=0&id=7b23c516&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23c516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b23c516')) {
      api.createRecord('7b23c516', component.options)
    } else {
      api.reload('7b23c516', component.options)
    }
    module.hot.accept("./RegisterShiftSubject.vue?vue&type=template&id=7b23c516&scoped=true", function () {
      api.rerender('7b23c516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attendance-v2/RegisterShiftSubject.vue"
export default component.exports